import Seo, { SITE_URL } from '@/components/seo';
import { PortfolioName } from '@/data/portfolio/portfolio-list-data';
import PortfolioBanner from './components/portfolio-banner';
import './portfolio-detail-page.scss';
import { useParams } from 'react-router-dom';
import { DETAIL_DATA } from '@/data/portfolio/portfolio-detail-data';
import PortfolioMockup from './components/portfolio-mockup';
import PortfolioProjectInfo from './components/portfolio-project-info';
import PortfolioFont from './components/portfolio-font';
import PortfolioColor from './components/portfolio-color';
import PortfolioContentImages from './components/portfolio-content-images';
import PortfolioNextBanner from './components/portfolio-next-banner';
import NotFoundPage from '@/pages/404/not-found-page';

const PortfolioDetailPage = () => {
	const { name } = useParams() as { name: PortfolioName };

	const data = DETAIL_DATA[name];

	if (!data) {
		return <NotFoundPage />;
	}

	return (
		<div className="portfolio-detail-page-wrapper">
			<Seo
				title={data.projectInfo.title}
				description={data.projectInfo.description.replace(/\n/g, ' ')}
				path={`/portfolio/${name}`}
				image={data.banner.backgroundImage}
				jsonLd={{
					'@context': 'https://schema.org',
					'@type': 'CreativeWork',
					name: data.projectInfo.title,
					description: data.projectInfo.description,
					url: `${SITE_URL}/portfolio/${name}`,
					image: `${SITE_URL}${data.banner.backgroundImage}`,
					creator: { '@id': `${SITE_URL}/#organization` },
					sourceOrganization: {
						'@type': 'Organization',
						name: data.projectInfo.clientName
					},
					keywords: `미스터디벨로, 포트폴리오, ${data.projectInfo.scope}`
				}}
			/>
			<PortfolioBanner banner={data.banner} />
			<PortfolioMockup mockup={data.mockup} />
			<PortfolioProjectInfo projectInfo={data.projectInfo} />
			<PortfolioFont font={data.font} />
			<PortfolioColor color={data.color} />
			<PortfolioContentImages contentImages={data.contentImages} />
			<PortfolioNextBanner />
		</div>
	);
};

export default PortfolioDetailPage;
